var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16349",
    "data-name": "Group 16349",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2_-_Outline",
    "data-name": "Ellipse 2 - Outline",
    d: "M29.5,0A29.5,29.5,0,1,0,59,29.5,29.5,29.5,0,0,0,29.5,0m0-3A32.491,32.491,0,0,1,52.481,52.481,32.5,32.5,0,1,1,16.849-.445,32.3,32.3,0,0,1,29.5-3Z",
    fill: "#00101f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fast-delivery",
    transform: "translate(12.179 17.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16357",
    "data-name": "Group 16357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12046",
    "data-name": "Path 12046",
    d: "M37.4,20.659,33.893,15.8a2.946,2.946,0,0,0-2.381-1.217H26.293v-1.8A2.689,2.689,0,0,0,23.608,10.1H8.98a1.355,1.355,0,0,0,0,2.71l14.6-.024V24.574a1.355,1.355,0,0,0,2.71,0V17.3h5.218a.229.229,0,0,1,.185.094l3.5,4.84.025,4.811H32.766a3.9,3.9,0,1,0,1.281,2.885c0-.059-.007-.117-.009-.176h1.185a2.688,2.688,0,0,0,2.685-2.685V22.231A2.673,2.673,0,0,0,37.4,20.659ZM30.137,31.128a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,30.137,31.128Z",
    transform: "translate(-3.763 -10.105)",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12047",
    "data-name": "Path 12047",
    d: "M8.271,39.466A3.89,3.89,0,0,0,5.642,40.49H1.855a1.355,1.355,0,0,0,0,2.71H4.37c0,.059-.009.117-.009.176a3.91,3.91,0,1,0,3.91-3.91Zm0,5.11a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,8.271,44.576Z",
    transform: "translate(-0.5 -23.553)",
    fill: "#1a00e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16359",
    "data-name": "Group 16359",
    transform: "translate(0 5.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12048",
    "data-name": "Path 12048",
    d: "M31.293,41.356H25.641a1.355,1.355,0,1,0,0,2.71h5.652a1.355,1.355,0,1,0,0-2.71Z",
    transform: "translate(-11.394 -30.133)",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16358",
    "data-name": "Group 16358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12049",
    "data-name": "Path 12049",
    d: "M1.855,23.359h9.988a1.355,1.355,0,1,0,0-2.71H1.855a1.355,1.355,0,0,0,0,2.71Z",
    transform: "translate(-0.5 -20.649)",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12050",
    "data-name": "Path 12050",
    d: "M7.5,31.985A1.355,1.355,0,0,0,8.855,33.34h9.988a1.355,1.355,0,1,0,0-2.71H8.855A1.355,1.355,0,0,0,7.5,31.985Z",
    transform: "translate(-3.706 -25.221)",
    fill: "#1a00e3"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.41e4aa14483f18e0d36b3d6a10489f67.svg";
export { ForwardRef as ReactComponent };